import React from 'react';
import i18n from '@/shared/i18n/i18n';

const NotFound: React.FC = () => {
  return <div>{i18n.t('errors.404')}</div>;
};

export default NotFound;
